<div
  #modalBackdrop
  class="modal__backdrop"
  (click)="close()"></div>

<aside class="modal__wrapper">
  <div
    #modalContainer
    class="modal__container"
    [style]="styles()"
    [attr.data-error]="isError() ? true : null">
    @let hasHeader = icon() || title();
    @if (hasHeader) {
      <header class="modal__header">
        @if (icon(); as icon) {
          <evc-icon
            class="modal__icon"
            size="md"
            [icon]="icon"></evc-icon>
        }

        @if (title(); as title) {
          <!-- TODO sanityze -->
          <h2
            class="modal__title"
            [innerHTML]="title"></h2>
        }
      </header>
    }

    @if (content(); as content) {
      <!-- TODO sanityze -->
      <div
        class="modal__content"
        [innerHTML]="content"></div>
    }

    @let hasActions = action() || cancelLabel();
    @if (hasActions) {
      @let color = isError() ? 'destructive' : 'primary';

      <footer class="modal__actions">
        @if (actionLabel(); as label) {
          <evc-button
            data-testid="modal-submit"
            modal-actions
            class="modal__action__confirm"
            [text]="label"
            [type]="color"
            (click)="confirm()"></evc-button>
        }

        @if (cancelLabel(); as label) {
          <evc-button
            data-testid="modal-cancel"
            modal-actions
            class="modal__action__cancel"
            frame="ghost"
            [text]="label"
            (click)="close()"></evc-button>
        }
      </footer>
    }
  </div>
</aside>
